'use client'

import Head from 'next/head'

import Plan from '@/components/subscription/Plan'
import PlanDetails from '@/components/subscription/PlanDetails'
import PlanUsage from '@/components/subscription/PlanUsage'
import PlanLimits from '@/components/subscription/PlanLimitsPanel'

const Subscription = () => {
  return (
    <>
      <Head>
        <title>Subscription</title>
        <meta name="description" content="Subscription" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className="grid grid-cols-12">
        <Plan className="col-span-12 lg:col-span-6 2xl:col-span-4 3xl:col-span-2" />
        <PlanDetails className="col-span-12 lg:col-span-6 2xl:col-span-4 3xl:col-span-3" />
        <PlanUsage className="col-span-12 lg:col-span-5 2xl:col-span-4 3xl:col-span-3" />
        <PlanLimits className="col-span-12 lg:col-span-7 2xl:col-span-6 3xl:col-span-4" />
      </div>
    </>
  )
}

export default Subscription
